import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import ScrollToTop from "./components/ScrollToTop";

// استدعاء الهياكل (Layouts) 
import StoreLayout from "./components/StoreLayout";
import AdminLayout from "./admin/AdminLayout";

// صفحات العميل
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Products from "./pages/Products";
import CartPage from "./pages/CartPage";
import OrdersPage from "./pages/OrdersPage";
import OrderDetails from "./pages/OrderDetails";
import ProductDetails from "./pages/ProductDetails";
import NotFound from "./pages/NotFound";
import Profile from "./pages/Profile";

// 👇 --- الصفحات الجديدة اللي ضفناها للفوتر --- 👇
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Refund from "./pages/Refund";
// 👆 -------------------------------------- 👆

// صفحات الآدمن
import AdminDashboard from "./admin/AdminDashboard";
import AdminCategories from "./admin/AdminCategories";
import AdminProducts from "./admin/AdminProducts";
import AdminOrders from "./admin/AdminOrders";
import AdminOrderDetails from "./admin/AdminOrderDetails";

// الحماية
import ProtectedRoute from "./auth/ProtectedRoute";
import AdminRoute from "./auth/AdminRoute";

export default function App() {
  const cartCount = 0; // افترض إن دي بتيجي من الـ Context أو الـ State بتاعتك

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {/* 1. مسارات العميل (محمية بـ StoreLayout) */}
        <Route element={<StoreLayout cartCount={cartCount} />}>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetails />} />

          {/* 👇 --- مسارات الصفحات الجديدة (عامة ومتاحة للكل) --- 👇 */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<Refund />} />
          {/* 👆 --------------------------------------------- 👆 */}

          <Route element={<ProtectedRoute />}>
            <Route path="/profile" element={<Profile />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/orders/:id" element={<OrderDetails />} />
          </Route>

          {/* صفحة الـ NotFound خليها دايماً آخر حاجة في مسارات العميل */}
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* 2. مسارات الآدمن (محمية بـ AdminLayout و AdminRoute) */}
        <Route path="/admin" element={<AdminRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="orders/:id" element={<AdminOrderDetails />} />
          </Route>
        </Route>

      </Routes>
    </BrowserRouter>
  );
}